import SpeedTest from "./SpeedTest";

export default SpeedTest;
